// @flow
import type { Hour, Minute, Meridiem, Time } from './types'
import moment from './moment'

// 01:11 AM
export const formatTime = (date: string): string =>
  moment(date).format('hh:mm A')

// 01
export const formatHour = (time: string): Hour =>
  moment(time, 'hh:mm A').format('hh')

// 11
export const formatMinute = (time: string): Minute =>
  moment(time, 'hh:mm A').format('mm')

// AM
export const formatMeridiem = (time: string): Meridiem =>
  moment(time, 'hh:mm A').format('A')

export const buildHourMinuteMeridianState = (time: string): Time => {
  const date = moment(time, 'hh:mm A')
  return {
    hour: date.format('hh'),
    minute: date.format('mm'),
    meridiem: date.format('A')
  }
}

// 6:32:05 PM
export const formatTimeWithSeconds = (date: string): string =>
  moment(date).format('h:mm:ss A')

// 18:32:05
export const formatTime24WithSeconds = (date: string): string =>
  moment(date).format('H:mm:ss')

// 01:11 AM - 02:22 PM
export const formatStartCloseTime = (startTime: string, closeTime: string) =>
  formatTime(startTime) + ' - ' + formatTime(closeTime)

// Wednesday, November 21st, 2012
export const formatDateLong = (date: Date): string =>
  moment(date).format('dddd, MMMM Do, YYYY')

// November 21st 2012
export const formatDateShort = (date: string): string =>
  moment(date).format('MMMM Do YYYY')

// 11/21/2012
export const formatDateNumeric = (date: string): string =>
  moment(date).format('MM/DD/YYYY')

// Jul-02-17
export const formatDateCompact = (date: string): string =>
  moment(date).format('MMM-DD-YY')

// 11/21/2012 at 6:32 PM
export const formatDateNumericWithTime = (date: string): string =>
  moment(date).format('MM/DD/YYYY [at] h:mm A')

// Jul-02-17 at 6:32 PM
export const formatDateCompactWithTime = (date: string): string =>
  moment(date).format('MMM-DD-YY [at] h:mm A')

// Wednesday, November 21st, 2012 at 6:32 PM
export const formatDateLongWithTime = (date: string): string =>
  moment(date).format('dddd, MMMM Do, YYYY [at] h:mm A')



// WEBPACK FOOTER //
// ./src/core/dateFormater.js